import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/ContactMe.scss';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { validateEmail } from '../utils/constants';
import SocialLinks from '../components/SocialLinks';

function ContactMe({ isMenuOpen, toggleMenu }) {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [error, setError] = useState({ name: '', email: '', message: '' });
	const navigate = useNavigate();

	const onChangeHandler = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const submitHandler = (e) => {
		e.preventDefault();
		const { name, email, message } = formData;

		let errors = { name: '', email: '', message: '' };
		if (!name.trim()) errors.name = 'This field is required';
		if (!email.trim()) errors.email = 'This field is required';
		else if (!validateEmail(email))
			errors.email = 'Please use a valid email address';
		if (!message.trim()) errors.message = 'This field is required';

		if (errors.name || errors.email || errors.message) {
			setError(errors);
			return;
		}

		setError({ name: '', email: '', message: '' });
		navigate('/success');
	};

	const fadeUp = {
		hidden: { opacity: 0, y: 20 },
		visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
	};

	return (
		<>
			<div className="Container">
				<div className="Wrapper">
					<Nav toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />

					<motion.div
						className="Contact-me-wrapper"
						initial="hidden"
						animate="visible"
						variants={fadeUp}
					>
						<hr className="First" />
						<div className="Get-in-touch-grid">
							<div className="Form-main-text-wrap">
								<h1 className="Main-text">Get in Touch</h1>
							</div>
							<div className="Small-inner-grid">
								<p className="Contact-Paragraph-text">
									I’d love to hear what you’re working on and explore how I can
									help. I’m open to new opportunities and always approach work
									with purpose, positivity, and attention to detail. You can
									find me on these platforms, or reach out via the form below.
								</p>
								<SocialLinks variant={'dark'}/>
							</div>
						</div>
						<hr className="Second" />
					</motion.div>
					<motion.div
						className="Form-wrapper"
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						variants={fadeUp}
					>
						<form className="Form" onSubmit={submitHandler} netlify>
							<div className="Form-main-text-wrap">
								<h1 className="Main-text">Contact Me</h1>
							</div>

							<div className="Form-control">
								{['name', 'email', 'message'].map((field) => (
									<motion.div
										key={field}
										className="Form-field"
										animate={
											error[field] ? { x: [0, -5, 5, -5, 5, 0] } : { x: 0 }
										}
										transition={{ duration: 0.4 }}
									>
										<label htmlFor={field}>
											{field === 'name'
												? 'Name'
												: field === 'email'
												? 'Email Address'
												: 'Message'}
										</label>
										<input
											id={field}
											name={field}
											type="text"
											placeholder={
												field === 'name'
													? 'Jane Doe'
													: field === 'email'
													? 'abc@example.com'
													: 'How can I help?'
											}
											onChange={onChangeHandler}
											value={formData[field]}
										/>
										<span className="errorMsg">{error[field]}</span>
									</motion.div>
								))}
								<button className="Color-button-wrap">
									<span className="Color-button-text">Send Message</span>
								</button>
							</div>
						</form>
					</motion.div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default ContactMe;
